"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultRowProperty = exports.enumParityClass = void 0;

/**
 * @desc
 * Parity classes.
 *
 * @enum
 *
 * @type {{EVEN: string, ODD: string}}
 */
var enumParityClass = {
  EVEN: 'even',
  ODD: 'odd'
};
/**
 * @desc
 * Default values.
 *
 * @constant
 */

exports.enumParityClass = enumParityClass;
var defaultRowProperty = 'rowId';
exports.defaultRowProperty = defaultRowProperty;
//# sourceMappingURL=constants.js.map